import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type PackagesToolbarProps = {
  canManage?: boolean;
  onCreate?: () => void;
};

export function PackagesToolbar({
  canManage,
  onCreate,
}: PackagesToolbarProps) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="flex items-center font-bold text-2xl tracking-tight">
          ແພັກເກດຮຽນສ່ວນຕົວ
        </h2>
        <p className="text-muted-foreground">
          ຈັດການແພັກເກດຮຽນສ່ວນຕົວໃນລະບົບ.
        </p>
      </div>
      {canManage && onCreate && (
        <div className="flex items-center space-x-2">
          <Button onClick={onCreate}>
            <PlusIcon className="h-4 w-4" />
            ສ້າງແພັກເກດ
          </Button>
        </div>
      )}
    </div>
  );
}
